import styled from "styled-components";
import {SIZES} from "@/components/constants";
import {HEADER_MENU} from "@/components/constants/routes";
import Logo from "@public/assets/logo/logo.png"
import {usePathname, useRouter} from "@/i18n/navigation";
import {useDispatch, useSelector} from "react-redux";
import {sideNavControl} from "@/redux/NavigationSlice";
import {useLocale, useTranslations} from "next-intl";
import LocaleSelect from "@/components/layout/LocaleSelect";


const Header = () => {
    const pathName = usePathname();
    const locale = useLocale();
    const router = useRouter()
    const dispatch = useDispatch();
    const langData = useSelector(state => state.language.data);
    const sideNavState = useSelector((state) => state.navigation.sideNavState);
    const currentPath = pathName === `/${locale}` ? "/" : pathName.replace(`/${locale}`, "");
    const isActive = (item) => {
        let mark;
        if(!item.path) return;
        if(item.path === "/"){
            mark = currentPath === "/"
        } else {
            mark = currentPath.startsWith(item.path)
        }
        return mark;
    }

    return(
        <HeaderWrap>
            <div className={"container"}>
                <div className={"head-wrap"}>
                    <div className={"logo-area"} onClick={() => {router.push("/")}}><img src={Logo?.src} alt={"신트로밸리 로고"} /></div>

                    <ul className={"menu-wrap"}>
                        {
                            langData &&
                            HEADER_MENU.filter((item) => item.active).map((item, idx) =>
                                <li key={idx}
                                    className={`${isActive(item) ? "active" : ""}`}
                                    onClick={() => {
                                        if (!item.outside) {
                                            router.push(item.path);
                                        } else {
                                            window.open(item.path, "_blank", "noopener,noreferrer");
                                        }
                                    }}
                                >
                                    <div dangerouslySetInnerHTML={{__html: langData[item.key]}}/>
                                </li>
                            )
                        }
                        <li><LocaleSelect /></li>
                    </ul>

                    <div className={"toggle-inner"}>
                        <LocaleSelect />
                        <div
                            className={"toggle-btn"}
                            onClick={() => {
                                dispatch(sideNavControl(!sideNavState))
                            }}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth={1.5}
                                stroke="currentColor"
                                className="size-8"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                                />
                            </svg>
                        </div>


                    </div>
                </div>
            </div>
        </HeaderWrap>
    )
}
const HeaderWrap = styled.header`
    background-color: #FFF;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 10;

    .container {
        margin: 0 auto;
        padding: 7px 20px;

        .head-wrap {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .logo-area {
                width: 136px;
                cursor: pointer;
            }

            .menu-wrap {
                display: none;
                align-items: center;
                gap: 40px;
                li{
                    font-size: 16px;
                    line-height: 24px;
                    font-weight: 700;
                    color: #000;
                    cursor: pointer;
                    &.active{
                        color: #07903a;
                    }
                }
            }
            .toggle-inner{
                display: flex;
                align-items: center;
                gap: 10px;
                .toggle-btn{
                    cursor: pointer;
                    svg{
                        width: 32px;
                        height: 32px;
                    }
                }
            }
        }
    }
    
    @media (min-width: ${SIZES.MOBILE}) {
        .container {
            max-width: 640px;
        }
    }
    @media (min-width: ${SIZES.MOBILE_L}) {
        .container {
            max-width: 768px;

        }
    }
    @media (min-width: ${SIZES.TABLET}) {
        .container {
            max-width: 1024px;
            .head-wrap{
                .menu-wrap{
                    display: flex;
                }
                .toggle-inner{
                    display: none;
                }
            }
        }
    }
    @media (min-width: ${SIZES.TABLET_L}) {
        .container {
            max-width: 1280px;

        }
    }
    @media (min-width: ${SIZES.PC}) {
        .container {
            max-width: 1536px;
        }
    }
`
export default Header